import { ultraWideModalStyles } from '@/components/Elements/Modal/customStyles';
import { PaymentsModal } from '@/components/Elements/PaymentsModal';
import { FormUserAccount, FormUserAccountProps } from '@/components/Form/FormUserAccount';
import { ProductTypes } from '@/types';

export interface iFormUserAccountInModalProps
  extends Omit<FormUserAccountProps, 'onCancelButton' | 'onRequestInfo'> {
  isOpen: boolean;
  shouldCloseOnOverlayClick?: boolean;
  onRequestClose: () => void;
  onRequestInfo: (product: ProductTypes | null) => void;
  onCancelButton: (product: ProductTypes | null) => void;
}

export const FormUserAccountInModal = ({
  isOpen,
  shouldCloseOnOverlayClick,
  onRequestClose,
  onSubmit,
  countries,
  provinces,
  tinDocumentTypes,
  countryOnChange,
  actionButton,
  onCancelButton,
  onRequestInfo,
  groupId,
  showPaymentCheckout,
  showAgreementsCheck,
  product = null,
  currency,
  billingMode,
}: iFormUserAccountInModalProps) => {
  const onDefaultRequestClose = () => {
    onRequestClose();
  };

  const onDefaultRequestInfoOpen = () => {
    onRequestInfo && onRequestInfo(product);
  };

  const onDefaultCancelProduct = () => {
    onCancelButton && onCancelButton(product);
  };

  return (
    <PaymentsModal
      isOpen={isOpen}
      style={ultraWideModalStyles}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={onDefaultRequestClose}
    >
      <FormUserAccount
        className="pr-5 overflow-y-auto max-h-[75vh] min-w-screen-md"
        countries={countries}
        provinces={provinces}
        tinDocumentTypes={tinDocumentTypes}
        countryOnChange={countryOnChange}
        groupId={groupId}
        actionButton={actionButton}
        showCancelButton={true}
        showFooter={true}
        showPaymentCheckout={showPaymentCheckout}
        showAgreementsCheck={showAgreementsCheck}
        product={product}
        currency={currency}
        billingMode={billingMode}
        onSubmit={onSubmit}
        onCancelButton={onDefaultCancelProduct}
        onRequestInfo={onDefaultRequestInfoOpen}
        isModalForm={true}
      />
    </PaymentsModal>
  );
};
